import React from 'react';
import { motion } from 'framer-motion';
import { civicCapabilities } from '../../data/research';
import { fadeUp } from '../../utils/motion';
export function CognarchicFoundation() {
  return <section className="bg-navy-deep text-white py-20 lg:py-28" data-id="element-1176" data-mp="7ijpz7fjxk13">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-1177" data-mp="7l5u0x38hhek">
        <motion.div {...fadeUp} className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-16 mb-16" data-id="element-1178" data-mp="2j6u5x6pd2md">
          <h2 className="lg:col-span-5 font-heading font-bold text-4xl lg:text-5xl tracking-tight leading-tight" data-id="element-1179" data-mp="3tr1g5x8bd2lt">
            A possible foundation for the Cognarchic State
          </h2>
          <div className="lg:col-span-7 space-y-5" data-id="element-1180" data-mp="3k1hw4o8v72pd">
            <p className="text-xl text-white leading-relaxed" data-id="element-1181" data-mp="3fyv0ec92oxmw">
              The Cognarchic State is a proposed governance model centered on
              developing judgment and aligning responsibility with demonstrated
              capability. SKP could provide its knowledge foundation: approved
              capability definitions, research, rubrics, policy versions, role
              requirements, and the relationships among them.
            </p>
            <p className="text-lg text-white/75 leading-relaxed" data-id="element-1182" data-mp="1eiiwkbxvt7ks">
              A complete civic application would require additional systems to
              assess people, deliver services, manage cases, and independently
              review consequential decisions. Our research architecture groups
              that work into five major capabilities.
            </p>
          </div>
        </motion.div>

        <ol className="border-t border-white/15" data-id="element-1183" data-mp="1xg22h6p1ma2z">
          {civicCapabilities.map((capability, index) => <motion.li key={capability.title} {...fadeUp} className="grid grid-cols-1 lg:grid-cols-12 gap-4 lg:gap-16 border-b border-white/15 py-8" data-id="element-1184" data-mp="1jiwx78x5lf8s" data-mpi={index}>
              <div className="lg:col-span-5 flex gap-5" data-id="element-1185" data-mp="83qg85wd68t3">
                <span className="font-heading font-extrabold text-3xl text-teal leading-none w-8 shrink-0" data-id="element-1186" data-mp="d1rv0emrblyr">
                  {index + 1}
                </span>
                <h3 className="font-heading font-bold text-xl lg:text-2xl" data-id="element-1187" data-mp="3l2eurzwvdz9m">{capability.title}</h3>
              </div>
              <p className="lg:col-span-7 text-white/75 leading-relaxed" data-id="element-1188" data-mp="3gb6fin8uzjoj">{capability.body}</p>
            </motion.li>)}
        </ol>
      </div>
    </section>;
}